import {
  makeStyles,
  Skeleton,
  SkeletonItem,
  tokens,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const useClasses = makeStyles({
  wrapper: {
    maxWidth: "1000px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  title: {
    marginBottom: tokens.spacingVerticalM,
  },
  label: {
    marginTop: tokens.spacingVerticalM,
    marginBottom: tokens.spacingVerticalS,
  },
  link: {
    marginBottom: tokens.spacingVerticalM,
  },
  fieldBlock: {
    marginTop: tokens.spacingVerticalS,
    marginBottom: tokens.spacingVerticalS,
  },
  table: {
    marginTop: tokens.spacingVerticalS,
    marginBottom: tokens.spacingVerticalL,
  },
  tableRow: {
    marginBottom: tokens.spacingVerticalS,
  },
  buttons: {
    display: "flex",
    gap: "10px",
    marginTop: tokens.spacingVerticalL,
  },
  button: {
    width: "120px",
  },
});

export const ToolOverviewSkeleton = () => {
  const classes = useClasses();
  const { t } = useTranslation();

  return (
    <div className={classes.wrapper}>
      <Skeleton aria-label={t("loading")}>
        <SkeletonItem className={classes.title} size={32} shape="rectangle" />

        <SkeletonItem className={classes.label} size={20} />

        <SkeletonItem className={classes.link} size={24} />

        <SkeletonItem className={classes.fieldBlock} size={20} />
        <SkeletonItem className={classes.fieldBlock} size={32} />

        <SkeletonItem className={classes.fieldBlock} size={20} />
        <SkeletonItem className={classes.fieldBlock} size={32} />

        <SkeletonItem className={classes.fieldBlock} size={20} />
        <SkeletonItem className={classes.fieldBlock} size={32} />

        <SkeletonItem className={classes.label} size={20} />
        <div className={classes.table}>
          <SkeletonItem className={classes.tableRow} size={40} />
          <SkeletonItem className={classes.tableRow} size={40} />
          <SkeletonItem className={classes.tableRow} size={40} />
        </div>
      </Skeleton>
    </div>
  );
};
